import * as Yup from 'yup'
import { TFunction } from 'i18next'

import { get } from '~/util/api/get'
import { getCountryCodeByCurrentDomain } from '~/util/domain/getCountryCodeByCurrentDomain'

// eslint-disable-next-line @typescript-eslint/naming-convention
const getOTCPattern = (): RegExp => {
  switch (getCountryCodeByCurrentDomain()) {
    case 'ES':
      return /^JJD0002670[0-9]{10}001$/
    case 'PT':
      return /^JJD0003670[0-9]{10}001$/
    default:
      return /^JVGLOTC[0-9]{10}$/
  }
}

export const createTrackerCodeValidationSchema = (isRequired: boolean) => (t: TFunction) => {
  if (isRequired) {
    return Yup.string()
      .nullable()
      .required(t('errorKeys.error_field_required'))
      .matches(getOTCPattern(), t('errorKeys.error_invalid_otc_tracker_code'))
      .test(
        'is-trackercode-available',
        t('errorKeys.error_unavailable_otc_tracker_code'),
        (value: string | undefined | null) => {
          if (!value || !value.match(getOTCPattern())) {
            return true
          }

          return get(`/api/trackandtrace/${value}/available`)
        }
      )
  }

  return Yup.mixed().nullable().oneOf([null])
}
